import { render, staticRenderFns } from "./TwoFactorForm.vue?vue&type=template&id=ada87024"
import script from "./TwoFactorForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports